import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Philosophy from "./pages/Philosophy";
import Team, { TeamMember } from "./pages/Team";
import Contact from "./pages/Contact";
import PrivacyNoticePage from "./pages/Privacy";
import SitemapPage from "./pages/Sitemap";
import Services from "./pages/Services";
import CareerPage from "./pages/Careers";
import BlogPage from "./pages/Blogs";
import CareerDetailPage from "./pages/CareerDetailPage";
import BlogPostPage from "./pages/BlogPostPage";
import ServiceDetail from "./components/ServiceDetail";

function App() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Navbar />
      <div className={isHome ? "" : "page-with-footer"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/:memberId" element={<TeamMember />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/privacy-policy" element={<PrivacyNoticePage />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/careers" element={<CareerPage />} />
          <Route path="/careers/:jobSlug" element={<CareerDetailPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:postSlug" element={<BlogPostPage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
